import { isZignalyStaging } from '../../../../../../whitelabel';
import { MIN_INVESTMENT_FIREBLOCKS } from '../../../../../../util/constants';

export const PAYBIS_STATUS_CHECK_INTERVAL = 5_000;
export const PAYBIS_REFETCH_QUOTE_DEBOUNCE = 750;
export const currencyTo = 'USDT-BEP20';
export const minAmount = isZignalyStaging ? 5 : MIN_INVESTMENT_FIREBLOCKS;
